import ImageService from 'lib/ImageService'
// import {getPrivateUrl,getPublicImageUrl,getPublicImageUrl} from '../../lib/ImageService'
const defaultImg = require('../../images/pic_default.png')
/**
 * 自定义小程序图片组件
 */
Component({
  externalClasses: ["class-name"],
  /**
   * 组件的属性列表
   */
  properties: {
    size: String,
    styleInfo: String, // 兼容低版本oppo vivo 三星 对externalClasses的兼容异常 过渡方案 建议后期兼容后移除
    tfsKey: {
      type: String,
      value: "",
      observer: function (tfsKey) {
        if (!this.data.isPublic) {
          this.setData({
            src: ImageService.getPrivateUrl(tfsKey, this.data.size)
            // src: getPrivateUrl(tfsKey, this.data.size)
          });
          return;
        }
        this.setData({
          src: ImageService.getPublicImageUrl(tfsKey, this.data.size)
          // src: getPublicImageUrl(tfsKey, this.data.size)
        });
      }
    },
    mode: {
      type: String,
      value: "scaleToFill"
    },
    isPublic: {
      type: Boolean,
      value: true
    },
    src: {
      type: String
    }
  },

  /**
   * 组件的初始数据
   */
  data: {
    src: defaultImg
  },

  /**
   * 组件的方法列表
   */
  methods: {
    handleError: function (e) {
      this.setData({
        src: defaultImg
      });
    }
  }
});
